import { createFileRoute } from '@tanstack/react-router';
import type { JSX } from 'react';

import { DuplicateExpensePage } from '@/areas/manufacturing-templates/Expenses/ExpensesCreation/DuplicateExpensePage';
import { canCreateManufacturingTemplates } from '@/shared/permissions/pagePermissions';
import type { PageStaticData } from '@/shared/routing';

export const Route = createFileRoute('/_authenticated/next/templates/manufacturing/expenses/$expenseId/duplicate')({
    staticData: { access: { permissions: canCreateManufacturingTemplates }, chrome: 'none' } satisfies PageStaticData,
    component: RouteComponent,
});

function RouteComponent(): JSX.Element {
    const pathParams = Route.useParams();
    return <DuplicateExpensePage {...pathParams} />;
}
